import { Descriptions as AntdDescriptions, Tag } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Descriptions from "../../general/antd/descriptions";
import PageDetails from "../../general/details";
import { useNavigate, useParams } from "react-router-dom";
import Spin from "../../general/antd/spin";
import AppContext from "../../../context/app/context";
import IncentiveContext from "../../../context/incentive/context";
import IncentiveContextProvider from "../../../context/incentive/provider";

interface Props {}

const IncentiveDetailsComponent: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { details, actions, loading } = useContext(
    IncentiveContext
  );
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, [direction]);

  return (
    <>
      <PageDetails
        title={t("details")}
        subtitle={t("incentive")}
        buttonName={`${t("update_incentive")}`}
        onClick={() => navigate(`/incentives/update/${id}`)}
        loading={loading.includes("details")}
        onRefresh={() => actions.getDetails(Number(id))}
      >
        {loading.includes("details") ? (
          <Spin />
        ) : (
          <Descriptions size="small" column={1} bordered>
            <AntdDescriptions.Item label={t("id")}>
              {details?.id}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("name")}>
              {details?.name ?? "-"}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("description")}>
              {details?.description ?? "-"}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("cost")}>
              {details?.cost} {t("currency")}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("driver_classification")}>
              {details?.driverClassification?.name ?? "-"}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("status")}>
              {details?.status === 1 ? (
                <Tag icon={<CheckCircleOutlined />} color="success">
                  {t("active")}
                </Tag>
              ) : (
                <Tag icon={<CloseCircleOutlined />} color="default">
                  {t("inactive")}
                </Tag>
              )}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("created_at")}>
              {details?.createdAt
                ? new Date(details.createdAt).toLocaleString()
                : "-"}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("created_by")}>
              {details?.createdBy
                ? `${details.createdBy.firstName ?? ""} ${details.createdBy.lastName ?? ""}`.trim() || "-"
                : "-"}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("updated_at")}>
              {details?.updatedAt
                ? new Date(details.updatedAt).toLocaleString()
                : "-"}
            </AntdDescriptions.Item>

            <AntdDescriptions.Item label={t("updated_by")}>
              {details?.updatedBy
                ? `${details.updatedBy.firstName ?? ""} ${details.updatedBy.lastName ?? ""}`.trim() || "-"
                : "-"}
            </AntdDescriptions.Item>
          </Descriptions>
        )}
      </PageDetails>
    </>
  );
};

const IncentiveDetailsPage = () => {
  return (
    <IncentiveContextProvider>
      <IncentiveDetailsComponent />
    </IncentiveContextProvider>
  );
};

export default IncentiveDetailsPage;
